import React from 'react';
import { ShoppingCartOutlined, CalendarOutlined, FileTextOutlined, SelectOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import { message, Statistic, Button } from 'antd';
import classnames from 'classnames';
import CpSlideProductImg from './CpSlideProductImg';
import { preSaleStatus, renderStatusTagInfo, preSaleStatusActionText, preCountDownText } from '../../util/preSale';
import { amountToString } from '../../util/tool';
import { orderPlanTaskReserve } from '../../util/api';
import './cpProductCard.less';

const { Countdown } = Statistic;
class CpProductCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false,
      slideState: 'leave',
      slideImgList: [],
    };
  }
  imgRef = React.createRef();

  slideImgToShopChat() {
    const { slideImgList } = this.state;
    if (!this.shopCartEl) {
      this.shopCartEl = document.getElementById('shopCartTag');
    }
    this.setState({
      slideImgList: [...slideImgList, { state: 'enter' }],
    });
  }
  onImgLeave = (index) => {
    const { slideImgList } = this.state;
    slideImgList[index].state = 'leave';
    this.setState({
      slideImgList: [...slideImgList],
    });
  };

  add = () => {
    const { id, stock_cur_num, sale_max_count_day, sale_min_count, productsInCart, addProduct } = this.props;
    const cartProductInfo = productsInCart[id];
    let purchasedNum = 0;
    let total = 1;
    if (cartProductInfo) {
      purchasedNum = cartProductInfo.num || 0;
      total = purchasedNum + 1;
    }
    let max = +(sale_max_count_day) === 0 ? +(stock_cur_num) : (+(stock_cur_num) < +(sale_max_count_day)) ? +(stock_cur_num) : +(sale_max_count_day);
    if (total > max) {
      message.info('超过最大可购买量，不能再加了');
      return;
    }
    let min = purchasedNum <= 0 ? +(sale_min_count) : 1;
    this.slideImgToShopChat();
    addProduct && addProduct(min);
  }

  preAdd = async ({ is_pre_sale, pre_sale = {}, tagStatusInfo }) => {
    const { pre_sale_goods_id } = pre_sale;
    const { data: { code, msg } } = await orderPlanTaskReserve({ pre_sale_goods_id, number: 1 });
    if (+code === 0) {
      message.success('预定成功', .5, this.props.reFresh);
    } else {
      message.error(msg);
    }
  }

  addPlanList = () => {
    const { planListAddProduct } = this.props;
    planListAddProduct && planListAddProduct(1);
  }
  render() {
    const { hover, slideImgList } = this.state;
    const { price, imgUrl, stock, title, subTitle, end, toProductDetail = () => { }, transferOrder = () => { }, is_base_purchase = 0, pre_sale = {}, is_pre_sale = false, is_shop_cart, is_plan_list, redundancy = {}, out_sku_no } = this.props;
    const { sale_norms = [] } = redundancy;
    const { reFresh = () => { }, currency_en = "RMB", exchange_rate = 1, currency_symbol = "¥" } = this.props;
    const { status: pre_status = 0, is_reserve = false, pre_sale_goods_id = '', order_no = '' } = pre_sale;
    const tagStatusInfo = is_pre_sale && renderStatusTagInfo(pre_sale);
    const { computedStatus, countDownTime } = tagStatusInfo || {};
    const computed_sale_norms = sale_norms?.[0]?.sale_norms;
    return (
      <div className={classnames({ 'product-card': true, active: hover, end: end, })}>
        <div className="product-outline"></div>
        <div className="product-img-container" onClick={(e) => { e.stopPropagation(); toProductDetail(); }}>
          <img ref={this.imgRef} className="product-img" src={imgUrl || ''} alt={title} />
        </div>
        <div className="product-detail" onClick={(e) => { e.stopPropagation(); toProductDetail(); }}>
          <div className="product-sale-info">
            {/* {currency_en === "RMB" ? amountToString(price) : +amountToString(`${(+price / +exchange_rate)}`, 4)} */}
            <div className="product-price">
              {/* currency_en="RMB", exchange_rate=1, currency_symbol="¥" */}
              <span className="product-price-unit">{currency_symbol} </span>
              <span className="product-price-content">{currency_en === "RMB" ? amountToString(price) : amountToString(`${(+price / +exchange_rate)}`, 4)}</span>
            </div>
            <div className="product-stock">{`库存：${stock}`}</div>
          </div>
          <div className="product-title"><a>{title}</a></div>
          <div className="product-subTitle">{subTitle}</div>
          <div className='product—sale-norms'>{computed_sale_norms ? `规格：${computed_sale_norms}` : null}</div>
          <div className='product—sale-norms'>{!['', null, undefined, '-'].includes(out_sku_no) ? `ERP编码：${out_sku_no}` : null}</div>
          <div className='product-tags'>
            {is_base_purchase ? <span className='product-tag-location'>基地</span> : null}
            {pre_status && is_pre_sale ? <span className='product-tag-status'>{preSaleStatus[computedStatus]}</span> : null}
            {is_reserve ? <span className='product-tag-status'>已预订</span> : null}
          </div>
          {/* <div className='product-count-down'>{is_pre_sale && countDownTime && <Countdown prefix={`${preSaleStatusText[pre_status]}剩余时间:`} value={countDownTime} format="D天H时m分s秒" onFinish={() => reFresh} />}</div> */}
          <div className='product-count-down'>{is_pre_sale && countDownTime && <Countdown prefix={`${preCountDownText[computedStatus]}:`} value={countDownTime} format="D天H时m分s秒" onFinish={() => reFresh} />}</div>
        </div>
        <div className="shop-cart-btn-container">
          <>{(is_plan_list ? <div className='shop-cart-btn' onClick={(e) => { e.stopPropagation(); this.addPlanList(); }}>    <FileTextOutlined /><span className='product-info-title'>加入计划单</span>  </div> : null)}</>
          <>{(!is_plan_list && !is_pre_sale && !is_shop_cart ? <div className='shop-cart-btn' onClick={(e) => { e.stopPropagation(); toProductDetail(); }}>    <SelectOutlined /><span className='product-info-title'>查看详情</span>  </div> : null)} </>
          {
            !is_pre_sale ? //  is_pre_sale 是否预售商品
              (is_shop_cart ? <div className='shop-cart-btn' onClick={(e) => { e.stopPropagation(); this.add(); }}><ShoppingCartOutlined /><span className='product-info-title'>加入购物车</span></div> : null)
              : <>
                {/* 预售待开始：预订 置灰 */}
                {
                  computedStatus === 0 ? <Button className="shop-cart-btn" disabled icon={<CalendarOutlined />} >{preSaleStatusActionText[pre_status]}</Button> : null
                }
                {/* 预售：预订 */}
                {
                  (computedStatus === 1 ? <Button className="shop-cart-btn" icon={<CalendarOutlined />} onClick={(e) => { e.stopPropagation(); this.preAdd({ is_pre_sale, pre_sale, tagStatusInfo }); }} >{preSaleStatusActionText[pre_status]}</Button> : null)
                }
                {/* 采购待开始：（未预订）-》加入购物车置灰 （已预订）-》转订单置灰 */}
                {
                  (computedStatus === 2 || computedStatus === 3) ? (!is_reserve ?
                    // （未预订）-》加入购物车置灰
                    <Button className="shop-cart-btn" disabled={computedStatus === 2} icon={<ShoppingCartOutlined />} onClick={(e) => { e.stopPropagation(); this.add(); }} >{preSaleStatusActionText[pre_status + is_reserve]}</Button>
                    :
                    // （已预订）-》转订单置灰
                    <Button className="shop-cart-btn" icon={<CalendarOutlined />} disabled={computedStatus === 2} onClick={(e) => { e.stopPropagation(); transferOrder(pre_sale_goods_id, order_no); }} >{preSaleStatusActionText[pre_status + is_reserve]}</Button>) : ''
                }
              </>
          }
        </div>
        {(slideImgList || []).map((item, index) => item.state === 'enter' ? <CpSlideProductImg key={index} targetEl={this.shopCartEl} imgEl={this.imgRef.current} imgUrl={imgUrl} onLeave={() => { this.onImgLeave(index); }} /> : null)}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    productsInCart: state.shopCart.products,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CpProductCard);
